import React from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { BaseCard, CardField } from 'components'

export const CardPericiando = (props) => {
  moment.locale('pt-br', localization)
  const { periciando, handleClick } = props

  return (
    periciando ? (
      <BaseCard
        avatar="PERICIANDO"
        title="Periciando"
        onClick={() => handleClick(periciando.id)}
        onNovaAba={() => handleClick(periciando.id, true)}
      >
        <CardField label="CPF" value={periciando.cpf || 'NÃO INFORMADO'} />
        <CardField label={periciando.nome ? 'Nome' : periciando.alcunha ? 'Alcunha' : periciando.nomeSocial ? 'Nome Social' : 'NÃO INFORMADO'} value={periciando.nome || periciando.alcunha || periciando.nomeSocial || 'NÃO INFORMADO'} />
        <CardField label="Data de entrada" value={moment(periciando.createdAt).format('DD/MM/YYYY')} />
      </BaseCard>
    ) : null
  )
}
